import React, { useState } from "react";
import { motion } from "framer-motion";

const Vacancies = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  // const [showComingSoon, setShowComingSoon] = useState(false);

  // Jab showComingSoon true hoga, tab 45 seconds baad ise hide kar denge
  // useEffect(() => {
  //   if (showComingSoon) {
  //     const timer = setTimeout(() => {
  //       setShowComingSoon(false);
  //     }, 20000); // 45 seconds
  //     return () => clearTimeout(timer); // Cleanup function to prevent memory leak
  //   }
  // }, [showComingSoon]);

  const jobListings = [
    {
      id: 1,
      title: "Full Stack Developer",
      level: "Mid-Level",
      location: "Raipur",
      description:
        "Designing and implementing user interfaces using HTML, CSS, and JavaScript frameworks like React or Angular. Building and maintaining server-side application logic, databases...",
    },
    {
      id: 2,
      title: "Android Developer",
      level: "Mid-Level",
      location: "Raipur",
      description:
        "Developing and maintaining Android applications, implementing UI/UX designs, integrating with backend services, and ensuring optimal performance on various devices.",
    },
    {
      id: 3,
      title: "React Developer",
      level: "Mid-Level",
      location: "Raipur",
      description:
        "Building responsive user interfaces using React.js, implementing state management solutions, creating reusable components, and optimizing application performance.",
    },
    {
      id: 4,
      title: "PHP Developer",
      level: "Mid-Level",
      location: "Raipur",
      description:
        "Developing backend systems using PHP frameworks, designing and maintaining databases, implementing APIs, and ensuring secure and efficient server-side operations.",
    },
  ];

  return (
    <div className="relative w-full py-16 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 md:mb-0">
            Our current vacancies
          </h2>
          <div className="relative w-full md:w-80 lg:w-96">
            <input
              type="text"
              placeholder="Search job"
              className="w-full px-4 py-3 rounded-full bg-white text-gray-800 focus:outline-none"
            />
            <button className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* "Coming Soon" message - Default hidden, show on button click */}
        {/* {showComingSoon && ( */}
        <p className="text-white p-[10px] bg-[#ffffff31] rounded-lg text-center mb-12 text-[18px]">
          Coming soon
        </p>
        {/* )} */}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {jobListings.map((job) => (
            <motion.div
              key={job.id}
              className="relative overflow-hidden bg-indigo-50 rounded-lg cursor-pointer shadow-lg min-h-[350px] p-6"
              initial={{ opacity: 1 }}
              whileHover={{}}
              transition={{ duration: 0.3 }}
              onMouseEnter={() => setHoveredCard(job.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <motion.div
                className="absolute left-0 top-0 h-full w-[50%] bg-indigo-100 rounded-full"
                initial={{ x: "-50%" }}
                animate={hoveredCard === job.id ? { x: "150%" } : { x: "-50%" }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
              />
              <div className="relative z-10">
                <motion.h3
                  className="text-3xl md:text-4xl font-bold text-indigo-900"
                  animate={
                    hoveredCard === job.id
                      ? { fontSize: "1.5rem", marginTop: "0" }
                      : { fontSize: "2rem", marginTop: "5rem" }
                  }
                  transition={{ duration: 0.3 }}
                >
                  {job.title}
                </motion.h3>
                <motion.div
                  initial={{ opacity: 1, y: 0 }}
                  animate={hoveredCard === job.id ? { y: 10 } : { y: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="flex gap-2 mt-2">
                    <motion.span
                      className="px-3 py-1 bg-gray-200 rounded-md text-sm"
                      initial={{ opacity: 0, y: -10 }}
                      animate={
                        hoveredCard === job.id
                          ? { opacity: 1, y: 0 }
                          : { opacity: 0, y: -10 }
                      }
                      transition={{ duration: 0.3 }}
                    >
                      {job.level}
                    </motion.span>
                    <motion.span
                      className="px-3 py-1 bg-gray-200 rounded-md text-sm"
                      initial={{ opacity: 0, y: -10 }}
                      animate={
                        hoveredCard === job.id
                          ? { opacity: 1, y: 0 }
                          : { opacity: 0, y: -10 }
                      }
                      transition={{ duration: 0.3, delay: 0.1 }}
                    >
                      {job.location}
                    </motion.span>
                  </div>
                </motion.div>
                {hoveredCard === job.id && (
                  <motion.p
                    className="text-gray-700 mt-4"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    {job.description}
                  </motion.p>
                )}
                {hoveredCard === job.id && (
                  <motion.button
                    className="mt-4 ml-auto block px-4 py-2 border-2 border-indigo-500 text-indigo-500 rounded-full hover:bg-indigo-500 hover:text-white transition"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: 0.2 }}
                    // onClick={() => setShowComingSoon(true)}
                  >
                    Know More
                  </motion.button>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Vacancies;
